/** `aria-pressed` for a toggle, or nothing for a plain control (exactOptionalPropertyTypes). */
export function pressed(state: boolean | undefined): { "aria-pressed"?: boolean } {
  return state === undefined ? {} : { "aria-pressed": state };
}

/**
 * The `type` of a native button. Tamagui's props do not list it, so it travels as a spread; without
 * it a button inside a form submits the form.
 */
export function buttonType(type: "button" | "submit" | "reset" = "button"): { type: string } {
  return { type };
}
